export const EMIT_AVATAR_CLICK = "avatar-click";

export const DEFAULT_MENU_LASTMESSAGES = "messages";
export const DEFAULT_MENU_CONTACTS = "contacts";
export const DEFAULT_MENUS = [DEFAULT_MENU_LASTMESSAGES, DEFAULT_MENU_CONTACTS];
/**
 * 聊天消息类型
 */
export const MESSAGE_TYPE = ["voice", "file", "video", "image", "text"];

/**
 * 聊天消息状态
 */
export const MESSAGE_STATUS = ["going", "succeed", "failed"];

export const CONTACT_TYPE = ["many", "single"];
